import { useQuery } from "@tanstack/react-query";
import { Link, createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "~/components/ui/page-title";
import { pageEditorQueryOptions } from "~/lib/functions/organization-pages";

import { PageEditor } from "./-page-editor";

export const Route = createFileRoute(
  "/_user/my-organization/$slug/pages/$programId",
)({
  staticData: { title: "Program page" },
  loader: async ({ context, params }) => {
    const data = await context.queryClient.ensureQueryData(
      pageEditorQueryOptions({
        slug: params.slug,
        programId: params.programId,
      }),
    );
    return { title: data.page.name };
  },
  component: ProgramPagePage,
});

function ProgramPagePage(): React.JSX.Element {
  const { slug, programId } = Route.useParams();
  const { data } = useQuery(pageEditorQueryOptions({ slug, programId }));
  if (!data) return <></>;

  return (
    <div className="max-w-4xl space-y-8">
      <PageHeader
        eyebrow={`Program of ${data.organization.name}`}
        title={data.page.name}
        description={
          <>
            Your edits are a draft until DCM reviews and publishes them.{" "}
            <Link
              to="/my-organization/$slug/pages"
              params={{ slug }}
              search={{ tab: "programs" }}
              className="text-purple-700 underline underline-offset-2"
            >
              All programs
            </Link>
          </>
        }
      />
      <PageEditor data={data} target={{ slug, programId }} />
    </div>
  );
}
